import { createStore } from "vuex";
let root = undefined;

export const setAppRoot = (obj) => {
  root = obj;
};

const duration = 5 * 60 * 1000;

export default createStore({
  state: {
    classes: [],
    disks: [],
    runStatus: 0,
    netReachable: undefined,
    globalTimer: undefined,
    tick: undefined,
  },
  mutations: {
    setTick(state) {
      state.tick = Date.now();
      if (state.globalTimer) {
        clearTimeout(state.globalTimer);
      }
      state.globalTimer = setTimeout(() => {
        root.$router.push({ name: "Index" });
        clearTimeout(state.globalTimer);
      }, duration);
    },
    checkTick(state) {
      console.log("checkTick-00000", state.tick && Date.now() - state.tick);
      if (state.tick && Date.now() - state.tick > duration) {
        root.$router.push({ name: "Index" });
      }
    },
    init(state, initData) {
      // console.log('mutations init');
      state.classes = initData.classes;
      state.disks = initData.disks;
      state.runStatus = initData.runStatus;
      // state.netReachable = initData.netReachable;
    },
    initOne(state, initData) {
      state.classes = initData.classes;
      state.disks.forEach((i, index) => {
        initData.disks.forEach((j) => {
          if (i.id == j.id) {
            i.seats.forEach((q, index2) => {
              j.seats.forEach((k) => {
                if (q.id == k.id) {
                  state.disks[index].seats[index2] = k;
                  q = k;
                }
              });
            });
          }
        });
      });

      state.runStatus = initData.runStatus;
    },
    initNetSatus(state, status) {
      state.netReachable = status;
    },
  },
  actions: {},
  modules: {},
});
